<div mat-dialog-title>
  Data exporteren
  <button [mat-dialog-close]="false" class="mat-black" mat-flat-button>
    <mat-icon>close</mat-icon>
    Sluiten
  </button>
</div>
<div mat-dialog-content>
  <p>U probeert een groot aantal taken te exporteren, waardoor het exportproces langer kan duren dan gebruikelijk.</p>
</div>
<mat-dialog-actions>
  <button (click)="submitData.next()" color="primary" mat-flat-button>BEVESTIGEN</button>
</mat-dialog-actions>
<fury-loading-overlay [isLoading]="isLoading" [fill]="true"></fury-loading-overlay>
